import { render } from "./header-bar.vue?vue&type=template&id=06941825"
import script from "./header-bar.vue?vue&type=script&lang=js"
export * from "./header-bar.vue?vue&type=script&lang=js"

import "./header-bar.vue?vue&type=style&index=0&id=06941825&lang=css"
script.render = render

export default script